const TypeAccess = (props) => {
  return (
    <section className="chart-card transaction-form-card transaction-form-card-wide">
      <h2 className="transaction-section-title">Par catégorie</h2>
      <p className="transaction-section-hint">Remplissez tous les champs pour enregistrer une transaction détaillée.</p>

      <form onSubmit={(event) => props.formCompleteSubmitted(event)}>
        <div className="transaction-field-grid">
          <div className="transaction-field">
            <label htmlFor="inputCat">Catégorie</label>
            <select
              className="form-control"
              id="inputCat"
              onChange={(e) => props.handleSelectCat(e)}
              value={props.catSelect ? props.catSelect : ''}
            >
              <option value="">-- Choisir catégorie --</option>
              {props.allcat.map((e) => (
                <option key={e} value={e}>{e}</option>
              ))}
            </select>
          </div>

          <div className="transaction-field">
            <label htmlFor="inputSouscat">Sous-catégorie</label>
            <select
              className="form-control"
              id="inputSouscat"
              onChange={(e) => props.handleSelectSouscat(e)}
              value={props.souscatValue || ''}
            >
              {props.souscatSelect ? (
                props.souscatSelect.map((e) => (
                  <option key={e} value={e}>{e}</option>
                ))
              ) : (
                <option value="">-- Choisir sous-catégorie --</option>
              )}
            </select>
          </div>

          <div className="transaction-field transaction-field-full">
            <label htmlFor="inputDesc">Description</label>
            <select className="form-control" id="inputDesc">
              {props.descSelect ? (
                props.descSelect.map((e) => (
                  <option key={e} value={e}>{e}</option>
                ))
              ) : (
                <option value="">-- Choisir description --</option>
              )}
            </select>
          </div>

          <div className="transaction-field transaction-field-inline">
            <label htmlFor="inputQte">Quantité</label>
            <input
              type="number"
              className="form-control transaction-qte-input"
              id="inputQte"
              value={props.qteType}
              onChange={props.handleQteType}
            />
          </div>
        </div>

        <div className="transaction-field">
          <label htmlFor="inputNotes">Notes</label>
          <textarea
            placeholder="Notes optionnelles"
            className="form-control"
            rows="5"
            id="inputNotes"
          />
        </div>

        {props.saveSuccess && (
          <div className="transaction-success-banner" role="alert">
            La transaction a été enregistrée.
          </div>
        )}

        <div className="transaction-submit-row">
          <button type="submit" className="btn btn-primary">
            Valider
          </button>
        </div>
      </form>
    </section>
  );
};

export default TypeAccess;
